/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  initialDataLoading: true,
  isFetching: false,
  organizations: [],
  users: [],
  isSending: false,
};

const update = (organizations, organization = {}) =>
  organizations.map((oldOrganization) => {
    if (oldOrganization.id === organization.id) {
      return {
        ...oldOrganization,
        ...organization
      };
    }

    return oldOrganization;
  });

const updateDefaultOrganizationLevel = (
  prevDefaultID,
  newDefaultID,
  organizationID,
  organizations
) => {
  const updatedOrganization = organizations.find(
    (org) => org.id === organizationID
  );
  const { organization_levels } = updatedOrganization;
  const updatedLevels = organization_levels.map((orgLevel) => {
    if (orgLevel.id === newDefaultID) {
      return { ...orgLevel, default_level: true };
    }
    if (prevDefaultID && orgLevel.id === prevDefaultID) {
      return { ...orgLevel, default_level: false };
    }
    return orgLevel;
  });

  return updatedLevels;
};

const organizationReducer = (state = initialState, action) => {
  const { organizations, organization, organizationId } = action;
  let newOrganizations;
  switch (action.type) {
    case Types.REQUEST_ORGANIZATION_UPDATE:
    case Types.REQUEST_ORGANIZATION_CREATE:
    case Types.REQUEST_ORGANIZATIONS:
      return { ...state, isSending: true, isFetching: true };
    case Types.REQUEST_ORGANIZATIONS_FAILED:
      return { ...state, isSending: false, isFetching: false };
    case Types.RECEIVE_ORGANIZATIONS:
      return {
        ...state,
        isFetching: false,
        initialDataLoading: false,
        organizations
      };
    case Types.RECEIVE_ORGANIZATION_USER:
      newOrganizations = state.organizations.map((org) => {
        if (org.id === organizationId) {
          return {
            ...org,
            member_ids: [...org.member_ids, action.user.id]
          };
        }
        return org;
      });

      return {
        ...state,
        isFetching: false,
        users: state.users.concat(action.user),
        organizations: newOrganizations
      };
    case Types.UPDATE_ORGANIZATION:
      return {
        ...state,
        organization,
        isFetching: false,
        organizations: update([...state.organizations], organization)
      };
    case Types.CANCEL_ORGANIZATION_FETCHING:
      return { ...state, isSending: false, isFetching: false };
    case Types.ADD_TEAM_TO_ORGANIZATION: {
      const { team, organizationId } = action.payload;
      const newOrganizations = state.organizations.map((org) => {
        if (org.id === organizationId) {
          return {
            ...org,
            teams: org.teams.concat(team)
          };
        }
        return org;
      });
      return {
        ...state,
        organizations: newOrganizations
      };
    }

    case Types.UPDATE_DEFAULT_ORG_LEVEL:
      const { prevDefaultID, newDefaultID, organizationID } = action.payload;
      const updatedLevels = updateDefaultOrganizationLevel(
        prevDefaultID,
        newDefaultID,
        organizationID,
        state.organizations
      );
      const updatedOrganizations = state.organizations.map((org) => {
        if (org.id === organizationID) {
          return { ...org, organization_levels: updatedLevels };
        }
        return org;
      });

      return {
        ...state,
        organizations: updatedOrganizations
      };
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false, isSending: false }

    default:
      return state;
  }
};

export default organizationReducer;
